//#region Variables
$(document).ready(function(){
if(window.location.href.indexOf('?shape=') > -1){
  var shape = window.location.href.split('?shape=')[1];
  if(shape.indexOf('&stone=') > -1){
   var shape = shape.split('&stone=')[0];
    $('.shape-container-gemstones .shape-option[value="'+shape+'"]').trigger('click');
  }else{
    $('.shape-container-gemstones .shape-option[value="'+shape+'"]').trigger('click');
  }
    
}

$('.inner_main label').click(function(e){
  var _this1 = this;
  if($(this).parents('.inner_main_gems_slider').hasClass('Prefferd_gemstone')){
    $(this).parents('.inner_main_gems_slider').addClass('prefferd_active')
    var prefferd_gemstone =  $(this).attr('data-gemstone');
    var selecte_val = prefferd_gemstone.toLowerCase();
    $('.inner_main_gems_slider.main_gemstone_slide .inner_main').each(function(){
       var _this = $(this).find('.gemstone-shape-option');
       var mach_val =  $(this).find('.gemstone-shape-option').attr('id');
    
        if($(_this1).parents('.inner_main').find('.gemstone-shape-option').is(':checked')){
         if(mach_val.includes(selecte_val)){
          $(_this).prop("checked",false);
        }
         }else{
          
          if(selecte_val == 'color diamond'){
          //  alert(selecte_val);
             $('#gemstone-shape-black-diamond').prop("checked",true); 
             $('#gemstone-shape-pink-diamond').prop("checked",true); 
             $('#gemstone-shape-blue-diamond').prop("checked",true);
             $('#gemstone-shape-green-diamond').prop("checked",true);
             $('#gemstone-shape-brown-diamond').prop("checked",true);
          }
        if(mach_val.includes(selecte_val)){
          $(_this).prop("checked",true);
         
        }
       
        }
    })
  }
});
 

  $('.main_gems_slider.gemstone_slider_main').on('afterChange', function(event, slick, currentSlide, nextSlide){
    $('.gemstone-jumper-container gemstone-jumper').removeClass('active');
    currentSlide = currentSlide-1;
    $('.gemstone-jumper-container gemstone-jumper[data-index="'+currentSlide+'"]').addClass('active');
})

$('.main_gems_slider').slick({
  infinite: false,
  slidesToShow: 1, // Shows a three slides at a time
  slidesToScroll: 1, // When you click an arrow, it scrolls 1 slide at a time
  arrows: true, // Adds arrows to sides of slider
  dots: false, // Adds the dots on the bottom
  prevArrow: '<button class="slide-arrow prev-arrow"></button>',
  nextArrow: '<button class="slide-arrow next-arrow"></button>'

});
 // $('.gemstone-jumper').click(function(e) {
 //   e.preventDefault();
 //   $('button#btn-reset-filters').show();
 //   $('input.gemstone-shape-option').prop('checked',false);
 //   var thum_index = $(this).attr('data-index');
 //   var prefferd_no = parseInt(thum_index)+1;
 //   $('.main_gems_slider.gemstone_slider_main').slick('slickGoTo', prefferd_no);
 // });
  $('#seeprice').change(function(){
    if($(this).is(':checked')){
    $('.main_content_container').show()
    }else{
    $('.main_content_container').hide()
    }
})

  $('.tab-more-filters .more-arrow').click(function(){
    $(this).removeClass('active');
    if($(this).hasClass('filter-next')){
        $('.tab-more-filters .filter-before').addClass('active');
        $('.shop_by_gemstone').removeClass('active');
        $('.more_filter-container .more_filter').addClass('active');
        $('.main_gemstone_stone-container').removeClass('active').addClass('hidden');
        $('.inner_more_filters').addClass('active').removeClass('hidden');
    }else{
         $('.tab-more-filters .filter-next').addClass('active');
         $('.main_gemstone_stone-container').addClass('active').removeClass('hidden');
        $('.more_filter-container .more_filter').removeClass('active');
        $('.shop_by_gemstone').addClass('active');
        $('.inner_more_filters').removeClass('active').addClass('hidden');
        $('.main_gems_slider').slick('refresh');
    }
})
      $('.more_filter-container .tab').click(function(){
      if($(this).hasClass('shop_by_gemstone')){
        $('.tab-more-filters span.filter-before').trigger('click');
      }else
      {
      $('.tab-more-filters span.filter-next').trigger('click');
      }
      })
if(window.location.href.indexOf('?stone=') > -1){
var shape = window.location.href.split('?stone=')[1].replace(' ','-').toLowerCase();
$('.inner_main_gems_slider .inner_main').each(function(){
if($(this).find('.gemstone-shape-option').attr('id').indexOf(shape) >-1){
   $(this).find('label').trigger('click'); 
  var slide_index = $(this).parents('.inner_main_gems_slider').attr('data-slick-index');
  $('.main_gems_slider').slick('slickGoTo',slide_index);
}
})
}else if(window.location.href.indexOf('&stone=') > -1){
  var shape = window.location.href.split('&stone=')[1].replace(' ','-').toLowerCase();
  $('.inner_main_gems_slider .inner_main').each(function(){
if($(this).find('.gemstone-shape-option').attr('id').indexOf(shape) >-1){
   $(this).find('label').trigger('click'); 
  var slide_index = $(this).parents('.inner_main_gems_slider').attr('data-slick-index');
  $('.main_gems_slider').slick('slickGoTo',slide_index);
}
})
}
})
const RESULTS_PER_PAGE =30;
const DEFAULT_DIAMOND_IMAGE = 'https://cdn.shopify.com/s/files/1/0591/3663/9116/files/NoImage.png?v=1658497347';

let filters = {};
let gemstonesfilters = {};
let wishList=[];
let priceSlider = document.getElementById('slider-price');
let caratSlider = document.getElementById('slider-carat');
let polishSlider = document.getElementById('slider-polish');
let fluorSlider = document.getElementById('slider-fluor');

let typeView;

let initFiltValues = {
    price: [0, 463580],
    carat: [0.25, 11.58],
    table: [45, 87]
};
let timer;
const delay = 500;


//#endregion

//#region Create NoUI Filters

function createFilters() {

    noUiSlider.create(priceSlider, {
        connect: true,
        start: initFiltValues.price,
        step: 1,
        range: {
            'min': initFiltValues.price[0],
            'max': initFiltValues.price[1]
        },
        margin:10
    });
    // Let's create the carat's filter, if the wizard started form a setting then the boundaries are setted by the setting
    // otherwise the boundaries are setted by the default values
    let wizardInfo = JSON.parse(localStorage.getItem('latestSearchGemstone')); 
  
    let wizardStart;
    wizardStart= JSON.parse(localStorage.getItem('wizardStart'));
    let min_allowed_carat =  initFiltValues.carat[0];
    let max_allowed_carat = initFiltValues.carat[1];
    let allowed_shapes = [];
    if(wizardInfo != null){
        if(wizardInfo.setting_max_carat_size != null){
        max_allowed_carat = parseFloat(wizardInfo.setting_max_carat_size) + 0.10;
        min_allowed_carat = parseFloat(wizardInfo.setting_min_carat_size) - 0.10;
        allowed_shapes = wizardInfo.setting_allowed_shapes;
        initFiltValues.carat[0] = min_allowed_carat;
        initFiltValues.carat[1] = max_allowed_carat;
        }
    }

    noUiSlider.create(caratSlider, {
        connect: true,
        start: initFiltValues.carat,
        range: {
            'min': min_allowed_carat,
            'max': max_allowed_carat
        },
        margin:0.10
    });

    if(wizardInfo){
        //Let's check if there's a setting selected and hide the shapes that are not allowed by the setting
        if(wizardInfo.setting_allowed_shapes != null && wizardInfo.setting_allowed_shapes.length > 0){
            let shapes = document.getElementsByClassName('shape-container-2');
            for (let i = 0; i < shapes.length; i++) {
                //get the shape name after shape-container- string in the id of the element
                let shapeName = shapes[i].id.substring(16);
                let shapeNameCapitalized = shapeName.charAt(0).toUpperCase() + shapeName.slice(1);
                let shape = shapes[i];
                if(!wizardInfo.setting_allowed_shapes.includes(shapeNameCapitalized)){
                    shape.style.display = 'none';
                }
            }
        }
    }
}

//#endregion

//#Utils for images and V360
function isImage(url) {
    if(url === undefined || url === null) return false;
    return(url.match(/\.(jpeg|jpg|gif|png)$/) != null);
}

function isV360(url){
    if(url.indexOf('360') > -1){
        return true;
    }
    else{
        return false;
    }
}

function getDiamondImageUrl(diamond){
    if(isImage(diamond.image_url)){
        return `<img src='${diamond.image_url}'/>`;
    }       
    else{
        if(isV360(diamond.image_url)){
            //set the innerHTML to an iframe loading diamond.Image_URL
            return `<iframe data-src="${diamond.image_url}" src="" scrolling="no" width=420 height=420 sandbox="allow-scripts allow-orientation-lock allow-same-origin allow-pointer-lock"></iframe>`;        
        }
        else {
            return `<img src='${getDiamondLinesImgTableResults(diamond.shape)}'>`;
        }
    }
}


//#region Formats

function formatPrice(value, revert = false) {

    let format = wNumb({
        decimals: 0,
        thousand: ',',
        prefix: '$'
    });

    if (revert) {
        return format.from(value);
    }

    return format.to(value);
}

function formatPercentage(value, revert = false) {

    let format = wNumb({
        decimals: 2,
        mark: '.',
        suffix: ' %'
    });

    if (revert) {
        return format.from(value);
    }

    return format.to(value);
}

function toCurrencyFormat(snumber) {
    let currentCountryCode = $('body').attr('data-countrycode')
   let currentCurrencyCode = $('body').attr('data-currencysymbol');
  console.log(currentCountryCode,'code');
  console.log(currentCurrencyCode,'symbol');
   let locale = `en-${currentCountryCode}`;
    return parseFloat(snumber).toLocaleString(locale, {style:"currency", currency:currentCurrencyCode, minimumFractionDigits:2, maximumFractionDigits: 2});
}

function toNumberFormat(snumber) {
    return parseFloat(snumber).toLocaleString("en-US", {style:"decimal", minimumFractionDigits:2, maximumFractionDigits: 2});
}

//#endregion

//#region Bind Events

function bindEventsPrice() {

    priceSlider.noUiSlider.on('update', function (values) {
        document.getElementById('price-min').value = formatPrice(parseInt(values[0]));
        document.getElementById('price-max').value = formatPrice(parseInt(values[1]));
    });

    priceSlider.noUiSlider.on('change', () => {
        getPriceFilterValues();
        getResults();
    });

    document.getElementById('price-min').addEventListener('change', (e) => {
        priceSlider.noUiSlider.set([formatPrice(e.target.value, true), null]);
        getPriceFilterValues();
        getResults();
    });

    document.getElementById('price-max').addEventListener('change', (e) => {
        priceSlider.noUiSlider.set([null, formatPrice(e.target.value, true)]);
        getPriceFilterValues();
        getResults();
    });
}
 $('.gemstone-jumper').click(function(e) {
   e.preventDefault();
   $('button#btn-reset-filters').show();
   if($('.inner_main_gems_slider.prefferd_active').length > 0){
   $('.gemstone-shape-option').prop("checked",false);
  $('.inner_main_gems_slider').removeClass('prefferd_active');
   $('.bar-filter').remove();
   }
   filters.gemstones = [];
   filters.ColorHue = [];
   var thum_index = $(this).attr('data-index');
   var prefferd_no = parseInt(thum_index)+1;
   
    $('.main_gems_slider.gemstone_slider_main .inner_main_gems_slider .inner_main').each(function(){
     filters.gemstones.push($(this).find('input.gemstone-shape-option:checked').val());
    var shape_option  = $(this).find('input.gemstone-shape-option:checked').val();
    var colorhue =$(this).find('.container-img-gemstone input:checked').val();
    if(colorhue == undefined){
      colorhue = ''
    }
    filters.ColorHue.push(`{shape_option:${shape_option},colorhue:${colorhue}}`);
    })
    $('.main_gems_slider.gemstone_slider_main .inner_main_gems_slider[data-slick-index="'+prefferd_no+'"] .inner_main').each(function(){
    
    filters.gemstones.push($(this).find('input.gemstone-shape-option').val());
    var shape_option  = $(this).find('input.gemstone-shape-option').val();
    var colorhue =$(this).find('.container-img-gemstone input').val();
    if(colorhue == undefined){
      colorhue = ''
    }
    filters.ColorHue.push(`{shape_option:${shape_option},colorhue:${colorhue}}`);
   
    })
     setTimeout(function(){
     getgemstoneResults();
     },600)

   $('.main_gems_slider.gemstone_slider_main').slick('slickGoTo', prefferd_no);
 });
function bindEventsCarat() {
    caratSlider.noUiSlider.on('update', function (values) {
        document.getElementById('carat-min').value = values[0];
        document.getElementById('carat-max').value = values[1];
    });

    caratSlider.noUiSlider.on('change', () => {
        getCaratFilterValues();
        getResults();
    });

    document.getElementById('carat-min').addEventListener('change', (e) => {
        caratSlider.noUiSlider.set([e.target.value, null]);
        getCaratFilterValues();
        getResults();
    });

    document.getElementById('carat-max').addEventListener('change', (e) => {
        caratSlider.noUiSlider.set([null, e.target.value]);
        getCaratFilterValues();
        getResults();
    });
}

function bindEventsGemstones(){
   $('.gemstoner_wrapper_main .inner_main input').change(function(){
      var lab_attr = $(this).attr('id');
      
     
      if(!$(this).is(':checked')){
        $('.inner_main input[value="'+$(this).val()+'"]').prop('checked',false);
       $(this).prop('checked',false);
        if(window.location.href.indexOf('?shape=') > -1){
         var shape = window.location.href.split('?stone=')[1].replace(' ','-').toLowerCase();
        if(lab_attr.indexOf(shape)> -1){
          history.pushState({urlPath:'/pages/gemstones'},"",'/pages/gemstones')
          }
        }
      }else{
        $('.inner_main input[value="'+$(this).val()+'"]').prop('checked',true);
      }
       getGemstoneFilterValues();
    });
}

function bindEventsShapes() {
    //Let's check if the wizard started from a setting, if so we need to check the shape that is set in the LocalStorage wizardInfo.setting_selected_shape property
    
    let wizardInfo = JSON.parse(localStorage.getItem('latestSearchGemstone'));
    let wizardStart = JSON.parse(localStorage.getItem('wizardStart'));
    document.getElementById('shape-round').addEventListener('change', () => {
        getShapeFilterValues();
        getResults();
    });

    document.getElementById('shape-oval').addEventListener('change', () => {
        getShapeFilterValues();
        getResults();
    });

    document.getElementById('shape-heart').addEventListener('change', () => {
        getShapeFilterValues();
        getResults();
    });

    document.getElementById('shape-radiant').addEventListener('change', () => {
        getShapeFilterValues();
        getResults();
    });

    document.getElementById('shape-cushion').addEventListener('change', () => {
        getShapeFilterValues();
        getResults();
    });

    document.getElementById('shape-emerald').addEventListener('change', () => {
        getShapeFilterValues();
        getResults();
    });

    document.getElementById('shape-pear').addEventListener('change', () => {
        getShapeFilterValues();
        getResults();
    });

    document.getElementById('shape-princess').addEventListener('change', () => {
        getShapeFilterValues();
        getResults();
    });

    document.getElementById('shape-marquise').addEventListener('change', () => {
        getShapeFilterValues();
        getResults();
    });

    document.getElementById('shape-asscher').addEventListener('change', () => {
        getShapeFilterValues();
        getResults();
    });
}
function bindEventsQuality(){
   let wizardInfo = JSON.parse(localStorage.getItem('latestSearchGemstone'));
   let wizardStart = JSON.parse(localStorage.getItem('wizardStart'));
    

    document.getElementById('quality-good').addEventListener('change', () => {
        getQualityFilterValues();
        getResults();
    });

    document.getElementById('quality-fine').addEventListener('change', () => {
        getQualityFilterValues();
        getResults();
    });

    document.getElementById('quality-premium').addEventListener('change', () => {
        getQualityFilterValues();
        getResults();
    });

    document.getElementById('quality-exceptional').addEventListener('change', () => {
        getQualityFilterValues();
        getResults();
    });

   
}
function bindEventsCertificate(){
     let wizardInfo = JSON.parse(localStorage.getItem('latestSearchGemstone'));
   let wizardStart = JSON.parse(localStorage.getItem('wizardStart'));
    
    document.getElementById('certificate-certified').addEventListener('change', (e) => {
        getCertificateFilterValues(e);
        getResults();
    });

   document.getElementById('certificate-oneofakind').addEventListener('change', (e) => {
        getOnofkindFilterValues(e);
        getResults();
    });
  
}
function bindEventsTreatment(){

    document.getElementById('treated').addEventListener('change', () => {
        getTreatmentFilterValues();
        getResults();
    });

    document.getElementById('untreated').addEventListener('change', () => {
        getTreatmentFilterValues();
        getResults();
    });
}
function bindEventsOrigin(){
   
    document.getElementById('natural').addEventListener('change', () => {
        getOriginFilterValues();
        getResults();
    });

    document.getElementById('labcreated').addEventListener('change', () => {
        getOriginFilterValues();
        getResults();
    });
}
function bindEventsDimension(){
 
    document.getElementById('under-6mm').addEventListener('change', () => {
        getDimensionFilterValues();
        getResults();
    });

    document.getElementById('6-6-9mm').addEventListener('change', () => {
        getDimensionFilterValues();
        getResults();
    });
  document.getElementById('7-7-9mm').addEventListener('change', () => {
        getDimensionFilterValues();
        getResults();
    });
  document.getElementById('8-8-9mm').addEventListener('change', () => {
        getDimensionFilterValues();
        getResults();
    });
  document.getElementById('10-mm').addEventListener('change', () => {
        getDimensionFilterValues();
        getResults();
    });
}
function bindEventsTypes() {    
    document.getElementsByName('filter-types').forEach((input) => {
        input.addEventListener('change', () => {
            getTypeFilterValue();
            getResults();
        });
    });
}


function bindResetBtn() {
 
    document.getElementById('btn-reset-filters').addEventListener('click', () => {
       $('gemstone-jumper.gemstone-jumper').removeClass('active');
        $('.main_gems_slider').slick('slickGoTo', 0); 
        resetFilters();
    });
    document.getElementById('btn-reset-filters-2').addEventListener('click', () => {
        $('gemstone-jumper.gemstone-jumper').removeClass('active');
       
        $('.main_gems_slider').slick('slickGoTo', 0); 
        resetFilters();
    });
}


function bindSelectsCloseEvents() {
    document.addEventListener("click", closeAllSelectSort);
    document.addEventListener("click", closeAllSelectView);
}

function bindEventsWishListView(){
  document.getElementById("btn-container-wishList").addEventListener('click', event => { 
    typeView='wishList';
    createCardGridWishList();     
  });  
}

function bindEventsAllGemstoneView(){
  document.getElementById("btn-group-grilla").addEventListener('click', event => { 
      typeView='allDiamonds';
     // getResults();
  $('.compare_data #list-view').addClass('hidden');
    $('.result_container div#results').removeClass('hidden');
  });  
}

function bindEvents() {
    bindEventsGemstones();
    bindEventsPrice();
    bindEventsCarat();
    bindEventsShapes();
    bindEventsQuality();
    bindEventsCertificate();
    bindEventsTreatment();
    bindEventsOrigin();
    bindEventsDimension();
    bindEventsTypes();
    bindResetBtn();
    bindSelectsCloseEvents();
    bindEventsWishListView();
    bindEventsAllGemstoneView();
}

//#endregion

//#region Get Values Filters

function getPriceFilterValues() {
    let priceFilter = priceSlider.noUiSlider.get();
    filters.price_min = parseInt(priceFilter[0]).toString();
    filters.price_max = parseInt(priceFilter[1]).toString();
      let min_price = formatPrice(parseInt(priceFilter[0]))
      let max_price = formatPrice(parseInt(priceFilter[1]))
    if(parseInt(priceFilter[0]) > parseInt(initFiltValues.price[0]) || parseInt(priceFilter[1]) < parseInt(initFiltValues.price[1]))
    {
     if($('#bar-filter[data-name="Price"]').length < 1){
          bar_filter('Price',min_price,max_price);
      }else{
    $('#bar-filter[data-name="Price"] .main_fliter_text').text(`${min_price} - ${max_price} Price`)
     }
     }else{
      $('#bar-filter[data-name="Price"]').remove();
    } 
}

function getCaratFilterValues() {
    let caratFillter = caratSlider.noUiSlider.get();
    filters.carat_min = caratFillter[0].toString();
    filters.carat_max = caratFillter[1].toString();
  if(caratFillter[0] > initFiltValues.carat[0] || caratFillter[1] < initFiltValues.carat[1])
    {
       if($('#bar-filter[data-name="Carat"]').length < 1){
          bar_filter('Carat',caratFillter[0].toString(),caratFillter[1].toString());
      }else{
    $('#bar-filter[data-name="Carat"] .main_fliter_text').text(`${caratFillter[0].toString()} - ${caratFillter[1].toString()} Carat`)
     }
     }else{
      $('#bar-filter[data-name="Carat"]').remove();
    } 
  
}
function getTypeFilterValue() {    
    let types = document.getElementsByName('filter-types');    
    for (let i = 0, length = types.length; i < length; i++) {
        if (types[i].checked) {
            filters.search_type = types[i].value;
        }
    }  
}
function getCertificateFilterValues(e){
    filters.certificate = [];
    let optionCertified = document.getElementById('certificate-certified');
    if (optionCertified.checked === true) {
    filters.certificate.push(optionCertified.value);
      if($('#bar-filter[data-name="CERTIFIED"]').length < 1){
        bar_filter('CERTIFIED');
    }
    }else{
       $('#bar-filter[data-name="CERTIFIED"]').remove();
    }
}
function getOnofkindFilterValues(e){
    filters.certificate2 = [];
    let optionCertified = document.getElementById('certificate-oneofakind');
    if (optionCertified.checked === true) {
    filters.certificate2.push(optionCertified.value);
      if($('#bar-filter[data-name="oneofakind"]').length < 1){
        bar_filter('one of kind');
    }
    }else{
       $('#bar-filter[data-name="one of kind"]').remove();
    }
}

function getOriginFilterValues(){
   filters.origin = [];
    let optionNatural = document.getElementById('natural');
    let optionLabcreated = document.getElementById('labcreated');
    if (optionNatural.checked === true) {
        filters.origin.push(optionNatural.value);
      if($('#bar-filter[data-name="NATURAL"]').length < 1){
        bar_filter('NATURAL');
    }
    }else{
       $('#bar-filter[data-name="NATURAL"]').remove();
    }

    if (optionLabcreated.checked === true) {
        filters.origin.push(optionLabcreated.value);
    if($('#bar-filter[data-name="LAB CREATED"]').length < 1){
        bar_filter('LAB CREATED');
    }
    }else{
       $('#bar-filter[data-name="LAB CREATED"]').remove();
    }
}
function getDimensionFilterValues(){
  filters.dimension = [];
  let optionUNDER_6MM = document.getElementById('under-6mm');
  let option6_6_9MM = document.getElementById('6-6-9mm');
  let option_7_7_9MM = document.getElementById('7-7-9mm');
  let option8_8_9MM = document.getElementById('8-8-9mm');
  let option10_MM= document.getElementById('10-mm');
    if (optionUNDER_6MM.checked === true) {
        filters.dimension.push(optionUNDER_6MM.value);
      if($('#bar-filter[data-name="UNDER-6MM"]').length < 1){
        bar_filter('UNDER-6MM');
    }
    }else{
       $('#bar-filter[data-name="UNDER-6MM"]').remove();
    }

    if (option6_6_9MM.checked === true) {
        filters.dimension.push(option6_6_9MM.value);
    if($('#bar-filter[data-name="6-6.9MM"]').length < 1){
        bar_filter('6-6.9MM');
    }
    }else{
       $('#bar-filter[data-name="6-6.9MM"]').remove();
    }
    if (option_7_7_9MM.checked === true) {
        filters.dimension.push(option_7_7_9MM.value);
    if($('#bar-filter[data-name="7-7.9MM"]').length < 1){
        bar_filter('7-7.9MM');
    }
    }else{
       $('#bar-filter[data-name="7-7.9MM"]').remove();
    }
   if (option8_8_9MM.checked === true) {
        filters.dimension.push(option8_8_9MM.value);
    if($('#bar-filter[data-name="8-8.9MM"]').length < 1){
        bar_filter('8-8.9MM');
    }
    }else{
       $('#bar-filter[data-name="8-8.9MM"]').remove();
    }
  if (option10_MM.checked === true) {
        filters.dimension.push(option10_MM.value);
    if($('#bar-filter[data-name="10+MM"]').length < 1){
        bar_filter('10+MM');
    }
    }else{
       $('#bar-filter[data-name="10+MM"]').remove();
    }
  
}
function getTreatmentFilterValues (){
  filters.treatment = [];

    let optionTreated = document.getElementById('treated');
    let optionUntreated = document.getElementById('untreated');
    if (optionTreated.checked === true) {
        filters.treatment.push(optionTreated.value);
      if($('#bar-filter[data-name="TREATED"]').length < 1){
        bar_filter('TREATED');
    }
    }else{
       $('#bar-filter[data-name="TREATED"]').remove();
    }

    if (optionUntreated.checked === true) {
        filters.treatment.push(optionUntreated.value);
    if($('#bar-filter[data-name="UNTREATED"]').length < 1){
        bar_filter('UNTREATED');
    }
    }else{
       $('#bar-filter[data-name="UNTREATED"]').remove();
    }

}

function getQualityFilterValues(){
  filters.quality = [];

    let optionGood = document.getElementById('quality-good');
    let optionFine = document.getElementById('quality-fine');
    let optionExceptional = document.getElementById('quality-exceptional');
    let optionPremium = document.getElementById('quality-premium');
    if (optionGood.checked === true) {
        filters.quality.push(optionGood.value);
      if($('#bar-filter[data-name="Good"]').length < 1){
        bar_filter('Good');
    }
    }else{
       $('#bar-filter[data-name="Good"]').remove();
    }

    if (optionFine.checked === true) {
        filters.quality.push(optionFine.value);
    if($('#bar-filter[data-name="Fine"]').length < 1){
        bar_filter('Fine');
    }
    }else{
       $('#bar-filter[data-name="Fine"]').remove();
    }

    if (optionPremium.checked === true) {
    filters.quality.push(optionPremium.value);
      if($('#bar-filter[data-name="Premium"]').length < 1){
        bar_filter('Premium');
    }
    }else{
       $('#bar-filter[data-name="Premium"]').remove();
    }
   if (optionExceptional.checked === true) {
    filters.quality.push(optionExceptional.value);
      if($('#bar-filter[data-name="Exceptional"]').length < 1){
        bar_filter('Exceptional');
    }
    }else{
       $('#bar-filter[data-name="Exceptional"]').remove();
    }
}
  function getGemstoneFilterValues(){
  gemstonesfilters.gemstones = [];
  filters.gemstones = [];
  filters.ColorHue = [];
  $('.inner_main_gems_slider .inner_main').each(function(){
  if($(this).find('input.gemstone-shape-option').is(':checked')){
  gemstonesfilters.gemstones.push($(this).find('input.gemstone-shape-option').val())
  filters.gemstones.push($(this).find('input.gemstone-shape-option').val());
  var shape_option  = $(this).find('input.gemstone-shape-option').val();
  var colorhue =$(this).find('.container-img-gemstone input').val();
  if(colorhue == undefined){
    colorhue = ''
  }
  filters.ColorHue.push(`{shape_option:${shape_option},colorhue:${colorhue}}`);
  if($('#bar-filter[data-name="'+$(this).find('input.gemstone-shape-option').val()+'"]').length < 1){
        bar_filter($(this).find('input.gemstone-shape-option').val());
    }
    }else{
       $('#bar-filter[data-name="'+$(this).find('input.gemstone-shape-option').val()+'"]').remove();
    }
  })
   getgemstoneResults();
  }
function getShapeFilterValues() {
    filters.shapes = [];
    let optionRound = document.getElementById('shape-round');
    let optionOval = document.getElementById('shape-oval');
    let optionHeart = document.getElementById('shape-heart');
    let optionRadiant = document.getElementById('shape-radiant');
    let optionCushion = document.getElementById('shape-cushion');
    let optionEmerald = document.getElementById('shape-emerald');
    let optionPear = document.getElementById('shape-pear');
    let optionPrincess = document.getElementById('shape-princess');
    let optionMarquise = document.getElementById('shape-marquise');
    let optionAsscher = document.getElementById('shape-asscher');

    if (optionRound.checked === true) {
        filters.shapes.push(optionRound.value);
       if($('#bar-filter[data-name="Round"]').length < 1){
        bar_filter('Round');
    }
    }else{
       $('#bar-filter[data-name="Round"]').remove();
    }

    if (optionOval.checked === true) {
        filters.shapes.push(optionOval.value);
    if($('#bar-filter[data-name="Oval"]').length < 1){
        bar_filter('Oval');
    }
    }else{
       $('#bar-filter[data-name="Oval"]').remove();
    }

    if (optionHeart.checked === true) {
    filters.shapes.push(optionHeart.value);
      if($('#bar-filter[data-name="Heart"]').length < 1){
        bar_filter('Heart');
    }
    }else{
       $('#bar-filter[data-name="Heart"]').remove();
    }

    if (optionRadiant.checked === true) {
        filters.shapes.push(optionRadiant.value);
      if($('#bar-filter[data-name="Radiant"]').length < 1){
        bar_filter('Radiant');
      }
    }else{
         $('#bar-filter[data-name="Radiant"]').remove();
      }

    if (optionCushion.checked === true) {
        filters.shapes.push(optionCushion.value);
       if($('#bar-filter[data-name="Cushion"]').length < 1){
        bar_filter('Cushion');
      }
    }else{
         $('#bar-filter[data-name="Cushion"]').remove();
      }

    if (optionEmerald.checked === true) {
        filters.shapes.push(optionEmerald.value);
      if($('#bar-filter[data-name="Emerald"]').length < 1){
        bar_filter('Emerald');
      }
    }else{
         $('#bar-filter[data-name="Emerald"]').remove();
      }

    if (optionPear.checked === true) {
        filters.shapes.push(optionPear.value);
       if($('#bar-filter[data-name="Pear"]').length < 1){
        bar_filter('Pear');
      }
    }else{
         $('#bar-filter[data-name="Pear"]').remove();
      }

    if (optionPrincess.checked === true) {
        filters.shapes.push(optionPrincess.value);
      if($('#bar-filter[data-name="Princess"]').length < 1){
        bar_filter('Princess');
      }
    }else{
         $('#bar-filter[data-name="Princess"]').remove();
      }

    if (optionMarquise.checked === true) {
        filters.shapes.push(optionMarquise.value);
          if($('#bar-filter[data-name="Marquise"]').length < 1){
          bar_filter('Marquise');
          }
    }else{
             $('#bar-filter[data-name="Marquise"]').remove();
          }

    if (optionAsscher.checked === true) {
        filters.shapes.push(optionAsscher.value);
        if($('#bar-filter[data-name="Asscher"]').length < 1){
          bar_filter('Asscher');
          }
    }else{
         $('#bar-filter[data-name="Asscher"]').remove();
        }
}

//#endregion

//#region Reset Methods



function resetShapeFilter() {
    document.getElementById('shape-round').checked = false;
    document.getElementById('shape-oval').checked = false;
    document.getElementById('shape-heart').checked = false;
    document.getElementById('shape-radiant').checked = false;
    document.getElementById('shape-cushion').checked = false;
    document.getElementById('shape-emerald').checked = false;
    document.getElementById('shape-pear').checked = false;
    document.getElementById('shape-princess').checked = false;
    document.getElementById('shape-marquise').checked = false;
    document.getElementById('shape-asscher').checked = false;
}
function resetQualityFilter(){
    document.getElementById('quality-good').checked = false;
    document.getElementById('quality-fine').checked = false;
    document.getElementById('quality-premium').checked = false;
    document.getElementById('quality-exceptional').checked = false;
}
function resetCertificateFilter(){
    document.getElementById('certificate-certified').checked = false;
}
function resetTreatmentFilter(){
    document.getElementById('treated').checked = false;
    document.getElementById('untreated').checked = false;
}
function resetOriginFilter(){
    document.getElementById('natural').checked = false;
    document.getElementById('labcreated').checked = false;
}
function resetGemstoneFilter(){
    $('.inner_main input').prop('checked',false);
}
function resetDimensionFilter(){
    document.getElementById('under-6mm').checked = false;
    document.getElementById('6-6-9mm').checked = false;
    document.getElementById('7-7-9mm').checked = false;
    document.getElementById('8-8-9mm').checked = false;
    document.getElementById('10-mm').checked = false;
}
function resetFilters() {
    if(window.location.href.indexOf('?shape=') > -1 || window.location.href.indexOf('?stone=') > -1 ){
     history.pushState({urlPath:'/pages/gemstones'},"",'/pages/gemstones')
    }
    priceSlider.noUiSlider.set(initFiltValues.price);
    caratSlider.noUiSlider.set(initFiltValues.carat);
    resetShapeFilter();
    resetQualityFilter();
    resetCertificateFilter();
    resetTreatmentFilter();
    resetGemstoneFilter();
    resetOriginFilter();
    resetDimensionFilter();
    functionGetAllFiltersValues();
    getgemstoneResults();
    bar_filter('remove');
}

//#endregion

//#region Grid View Methods
function handlizeTitle(title) {
                // Convert to lowercase
                let handle = title.toLowerCase();
                // Replace spaces with hyphens
                handle = handle.replace(/\s+/g, '-');
                // Remove any special characters
                handle = handle.replace(/[^a-z0-9\-]/g, '');
                // Trim hyphens from the start and end
                handle = handle.replace(/^-+|-+$/g, '');
                return handle;
              }
var count = 0;

function createCardGrid(element,total_res,pagination,index,rendom_no,grid_wrapper,grid_wrapper2,grid_wrapper3,grid_wrapper4) {

  const month = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
var d = new Date();
var current_month = month[d.getMonth()];
var next_month = month[d.getMonth()+1];
var data_created_months = [];
var data_created_months_obj = {};
$('.shape-container1 input').each(function(){
    var getmstone_active = $(this).attr('data_created_month');
    if(current_month == getmstone_active ){
      data_created_months_obj[$(this).attr('data_gemstone_name')]=current_month
      data_created_months.push(data_created_months_obj);
    }
     else if(next_month == getmstone_active){
      data_created_months_obj[$(this).attr('data_gemstone_name')]=next_month
      data_created_months.push(data_created_months_obj);
    }
})
  
  if(pagination != true){
   count = index+1;
  }else{
   count = count+1;
  }
  $('#Huratips-Pagination .show-prod-content .total_show').text(count);
  var total_product = parseInt($('#Huratips-Pagination .show-prod-content .total_exist').text());
  var total_per = count*100/total_product;
  console.log(total_product);
  $('#Huratips-Pagination .loading-bar').html(`<style>.loading-bar::before { width: ${total_per}%;}</style>`);
  if(total_product <30 || $('div#pagination-zone ul#pagination-zone-nav li.page-item:last').hasClass('selected-page')){
    $('#Huratips-Pagination').hide()
  }else{
    $('#Huratips-Pagination').show()
  }
    let diamond_image='';
    // If element.shape.toLowerCase() contains cushion just keep cushion and remove extra words
   lowerCaseShape = element.Shape.toLowerCase();
    if(lowerCaseShape.includes('cushion')){
        lowerCaseShape = 'cushion';
    }
    
    let price = toCurrencyFormat(element.total_sales_price);
    let carat = toNumberFormat(element.size); 
    let table = toNumberFormat(element.table);  

    let card = document.createElement('div');
    let img_ele =  document.createElement('div');
    
    card.classList.add('col', 'aling-items-center', 'p-0', 'pb-4', 'col-card', 'mb-3');
    img_ele.classList.add('contentFoto', 'jtpl_collection_prd_pop_up');

      var img_src1=  $('#rapnet').attr('data-image1');
      var img_src2=  $('#rapnet').attr('data-image2');
      var img_src3=  $('#rapnet').attr('data-image3');
      var img_src4=  $('#rapnet').attr('data-image4');
      if(count == 9 && img_src1 != undefined){
       
      $(img_ele).html('<img src="'+img_src1+'" width="100%">');
        document.getElementById('grid-view').appendChild(img_ele);
      }else if(count == 26 && img_src2 != undefined){
         
        $(img_ele).html('<img src="'+img_src2+'" width="100%">');
        document.getElementById('grid-view').appendChild(img_ele);
      
    }else if(count == 35 && img_src3 != undefined){
         
        $(img_ele).html('<img src="'+img_src3+'" width="100%">');
        document.getElementById('grid-view').appendChild(img_ele);
      
    }else if(count == 48 && img_src4 != undefined){
         
        $(img_ele).html('<img src="'+img_src4+'" width="100%">');
        document.getElementById('grid-view').appendChild(img_ele);
      
    }
      else{
    let dimensionsStr  = '';
     if(element.Price2Total != '' && element.Price2Total != null && element.Price2Total != '-'){
     price =  parseFloat(element.Price2Total);
     }else{
     price = 0;
     }
     
      let currentRate = window.Shopify.currency.rate;  
     price = toCurrencyFormat(price * currentRate);

        
    if(element.measurements){
        dimensionsStr = `<h3 class="card-text card-title">Dimensions - ${element.measurements}</h3>`;
    }
    if($('#seeprice').is(':checked')){
      var price_show = 'display:block';
    }else{
       var price_show = 'display:none';
    }
        if(element.Lab == 'GIA'){
          var gai_icons = `<span class="gai_icons gemstone"><img src="https://cdn.shopify.com/s/files/1/0576/3350/5416/files/gia-logo.svg?v=1712654757" class="gai"></span>`
        }else{
          var gai_icons = '';
        }
        var tags = element.FullDescription;
        var decoded = tags.replace(/&lt;/g, "<").replace(/&gt;/g, ">");
      var match = decoded.match(/<certified>(.*?)<\/certified>/);
      
      if (match && match[1]) {
        console.log("Certified value:", match[1]); // Output: GIA
      } else {
        console.log("No <certified> tag found.");
      }
      if (data_created_months_obj[element.MatchingNum] != undefined) {
          var gemstone_birth_month = `<span class="gemstone_birth_month gemstone">${data_created_months_obj[element.MatchingNum]} Birthstone</span>`;
        } else if (match && match[1]) {
          var gemstone_birth_month = `<span class="gemstone_birth_month gemstone">${match[1]}</span>`;
        } else {
          var gemstone_birth_month = ""; // or any fallback/default value
        }
        var image_count = 0;
        let first_img ='';
        let second_img = '';
        let third_img = '';
        let forth_img = '';
        let slider_class= '';
        let _360icon = ''
        let _360_container = '';
        if(element.Image1 != null && element.Image1 != ''){
          image_count = image_count +1;
          first_img =  `<img src="${element.Image1}" class="card-img-top diamondcard-img">`
        }
        //console.log(element.Title+"---"+element.handle);
        if(element.handle != '' && element.handle != null){
          var p_handle = `/products/${element.handle}?page=gemstone`;
        }else if(element.Title != '' && element.Title != ''){
                var handle = handlizeTitle(element.Title);
                var p_handle = `/products/${handle}?page=gemstone`;
        }
         if(element.VideoUrl != null && element.VideoUrl != '-' && element.VideoUrl.indexOf('mp4') >-1){
        _360icon = `<span class="_360_icons gemstone"><img src="https://cdn.shopify.com/s/files/1/0576/3350/5416/files/360-view.svg?v=1712654633" class="_360_rotation"></span>`
         _360_container = `<div class="preview col" style="display:none">
    <div class="app-figure" id="zoom-fig">
        <a id="spin-${count}" class="Magic360"  data-options="autospin: infinite; autospin-stop: hover; spin: hover; rows: 1;columns: 72;magnify: false;"
            href="https://dsv7iunirnrax.cloudfront.net/360_gemstones/${element.Stock}/frame01.png"
        ><img src="https://dsv7iunirnrax.cloudfront.net/360_gemstones/${element.Stock}/frame01.png"></a>
       </div>
      </div>` 
         
         }else{
         
        if(element.Image2 != null && element.Image2 != '-' ){
          image_count = image_count +1;
         second_img = `<img src="${element.Image2}" class="card-img-top diamondcard-img">`
        }
        if(element.Image3 != null && element.Image3 != '-'){
          image_count = image_count +1;
           third_img =  `<img src="${element.Image3}" class="card-img-top diamondcard-img">`
        }
        if(element.Image4 != null && element.Image4 != '-' && element.Image4 != '\r'){
          image_count = image_count +1;
         forth_img =  `<img src="${element.Image4}" class="card-img-top diamondcard-img">`
        }
        if(image_count > 1){
          slider_class = 'main_slider'
        }
         }
         
     card.innerHTML = `
     
    <div class="card" id="${element.Stock}" >
        <div class="card-front">
            <div class=justify-content-center m-0">
               <div class="gemstone_image_wrapper">
               <div class="wrapper_inner">
                <a class="gemstone-card-link" href="${p_handle}">
               <div class="wrapper_main ${slider_class}">
                 ${first_img}
                 ${second_img}
                 ${third_img}
                 ${forth_img}
               </div>
               </a>
               ${_360_container}
               </div>
                ${gai_icons}
                ${_360icon}
                ${gemstone_birth_month}
                </div>             
            </div>
            <div class="main_content_container" style=${price_show}>
           
            <div class="card-body d-flex justify-content-between mt-3 ">
                <h4 class="card-text card-title test">${element.Title}</h4>
                
            </div>
            <div class="card-body d-flex justify-content-between main_price">
                <h4 class="card-text card-price">${price}</h4>
            </div>
            </div>
        </div>
    </div>`;
        if(count >9 && count<14 && img_src1 != undefined && element.handle !== null ){
          document.getElementById('grid-view').appendChild(grid_wrapper);
           grid_wrapper.appendChild(card);
        }else if(count >21 && count<26 && img_src2 != undefined && total_res >= 25 && element.handle !== null){
          document.getElementById('grid-view').appendChild(grid_wrapper2);
           grid_wrapper2.appendChild(card);
        }else if(count >35 && count< 40 && img_src3 != undefined && count >= 36 && element.handle !== null){
          document.getElementById('grid-view').appendChild(grid_wrapper3);
           grid_wrapper3.appendChild(card);
        }else if(count >48 && count<53 && img_src4 != undefined && count >= 48 && element.handle !== null){
          document.getElementById('grid-view').appendChild(grid_wrapper4);
           grid_wrapper4.appendChild(card);
        }
        else{
          if(element.handle !== null){
        document.getElementById('grid-view').appendChild(card);
        }
         //document.getElementById('grid-view').appendChild(card);
        }
        $(card).find('.main_slider').slick();
       $(`#${element.Stock}:not(.slick-arrow)`).on('click', function(e){
          e.preventDefault(); 
         if(!$(this).find('.slick-arrow').is(e.target)){
           if( !$(this).find('img._360_rotation').is(e.target)){
            setLocalStorageId(element.diamond_id,'',element,);
      
             if(element.handle != '' && element.handle != null){

              window.location.href = window.location.origin + '/products/' + element.handle +'?page=gemstone';
             } else{

               window.location.href = window.location.origin + '/products/' + handle +'?page=gemstone'; 
               
             }
        
           }
         }
    });
    // setTimeout(function(){
    //   var mainHeight = $('.gemstone_image_wrapper .wrapper_main img').height();
    //   $('#grid-view .diamondcard-img').css('min-height', mainHeight);
    //   $('#grid-view .diamondcard-img').css('max-height', mainHeight);
    //   },5000);    

      }
  
}   
  $(document).on('click','span._360_icons.gemstone',function(){
    setTimeout(function(){ 
    var mainHeight = $('.gemstone_image_wrapper .wrapper_main img').height();
    $('.preview .Magic360-container .Magic360').css('height', mainHeight);},1000);
    if($(this).parents('.gemstone_image_wrapper').find('canvas').length >0){
    $(this).parents('.gemstone_image_wrapper ').find('.wrapper_inner .diamondcard-img').show();
    $(this).parents('.gemstone_image_wrapper ').find('.wrapper_inner .wrapper_main').show();
    $(this).parents('.gemstone_image_wrapper').find('.wrapper_inner .preview').hide();
    var spiner =  $(this).parents('.gemstone_image_wrapper').find('.preview .Magic360').attr('id');
    Magic360.stop(`${spiner}`); 
    }else{
    $(this).parents('.gemstone_image_wrapper ').find('.wrapper_inner .diamondcard-img').hide();
    $(this).parents('.gemstone_image_wrapper ').find('.wrapper_inner .wrapper_main').hide();
    $(this).parents('.gemstone_image_wrapper').find('.wrapper_inner .preview').show();
    var spiner =  $(this).parents('.gemstone_image_wrapper').find('.preview .Magic360').attr('id');
    Magic360.start(`${spiner}`); 
    }
})
function getConfigSortGrid() {

    let selectSort = document.getElementById('selectSort');
    let valor = selectSort.options[selectSort.selectedIndex].value;
    let sortby;
    let sortDirection;
    let elements
    
    switch (valor) {
        case "-1":
            sortby = 'total_sales_price';
            sortDirection = 'ASC';
            elements = [sortby, sortDirection];
            break;
        case "1":
            sortby = 'total_sales_price';
            sortDirection = 'DESC';
            elements = [sortby, sortDirection];
            break;
        case "2":
            sortby = 'size';
            sortDirection = 'ASC';
            elements = [sortby, sortDirection];
            break;
        case "3":
            sortby = 'size';
            sortDirection = 'DESC';
            elements = [sortby, sortDirection];
            break;
        default:
            sortby = 'rand';
            sortDirection = 'ASC';
            elements = [sortby, sortDirection];
            break;
    }

    return elements;
}

function resetSortSelectGrid() {
    let sortSelect = document.getElementsByClassName('sort-select-items sort-select-hide')[0];

    sortSelect.childNodes.forEach(item => {item.classList.remove('same-as-selected-sort')});

    sortSelect.childNodes[0].setAttribute('class', 'same-as-selected-sort');

    let visualSelected = document.getElementsByClassName('sort-select-selected sort-custom-selected')[0];
    visualSelected.innerHTML = sortSelect.childNodes[0].innerHTML;
    
}

//#endregion

//#region Table View Methods


function resetHeadersTableResults() {
    let headerSorts = document.getElementById('table-results').querySelectorAll('[aria-sort]');
    for (var i = 0, ii = headerSorts.length; i < ii; i += 1) {

        let dir = 'DESC';
        if (i === 1) {
            dir = 'ASC'
        }

        headerSorts[i].setAttribute('aria-sort', dir);
    }
}

//#region Pagination

function getNumberOfPages(npage, totalOfPages) {
    document.getElementById('npage').textContent = npage;
    document.getElementById('npages').textContent = totalOfPages;
}

function callPage(obj, npage) {
let pagination =true;
    document.querySelectorAll('.selected-page')[0].classList.remove('selected-page');
    obj.parentElement.classList.add('selected-page');

    let sortby;
    let sortDirection;

    let viewSelected = document.getElementById('selectView').options[selectView.selectedIndex].value;
    if (viewSelected === 'list') {
        
        let sort_config_table = getSortConfigTableResults();
        sortby = sort_config_table[0];
        sortDirection = sort_config_table[1];
    }
    else {
        
        let sort_config_grid = getConfigSortGrid();
        sortby = sort_config_grid[0];
        sortDirection = sort_config_grid[1];
    }   
    
    // let col = [].slice.call(table.tHead.rows[0].cells).indexOf(header);
    // let sort_by = getSortByTableResults(col);
    
    
    // Set the new header sort.
    getResults(npage,pagination);
}

function createPaginationPages(currentPage, totalOfPages) {

    let pagElements = [];
    let paginationUL = document.getElementById('pagination-zone-nav');
    paginationUL.classList.remove('justify-content-between', 'justify-content-center');

    if (currentPage != 1) {
        let prevArrow = document.createElement('li');
        prevArrow.classList.add('page-item');
        prevArrow.innerHTML = `<a onclick="callPage(this, ${currentPage - 1})" aria-label="Previous">
            <svg width="12" height="12" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
            </svg>
        </a>`;

        paginationUL.appendChild(prevArrow);
    }

    if (totalOfPages === 1) {
        paginationUL.classList.add('justify-content-center');
    }
    else {
        paginationUL.classList.add('justify-content-between');
    }

    if (totalOfPages < 5) {
        for (let index = 1; index < totalOfPages + 1; index++) {
            pagElements.push(index);
        }
    }
    else {
        pagElements = [currentPage - 2, currentPage - 1, currentPage, currentPage + 1, currentPage + 2];

        if (currentPage === 1 || currentPage === 2 || totalOfPages === 5) {
            pagElements = [1, 2, 3, 4, 5];
        }

        if (currentPage === (totalOfPages - 1) || currentPage === totalOfPages) {
            pagElements = [totalOfPages - 4, totalOfPages - 3, totalOfPages - 2, totalOfPages - 1, totalOfPages];
        }
    }

    pagElements.forEach(page => {
        let li = document.createElement('li');
        li.classList.add('page-item');
        if (page === currentPage) li.classList.add('selected-page');
        li.innerHTML = `<a onclick="callPage(this, ${page})">${page}</a>`;
        paginationUL.appendChild(li);
    });

    if (currentPage != totalOfPages) {
        let nextArrow = document.createElement('li');
        nextArrow.classList.add('page-item');
        nextArrow.innerHTML = `<a onclick="callPage(this, ${currentPage + 1})" aria-label="Next">
            <svg width="12" height="12" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
            </svg>
        </a>`;

        paginationUL.appendChild(nextArrow);
    }
$(document).on('click','.load-more-product',function(){
  if($('#pagination-zone-nav li').length >1){
   if(!$('div#pagination-zone ul#pagination-zone-nav li.page-item:last').hasClass('selected-page')){
         $('div#pagination-zone ul#pagination-zone-nav li.page-item a:last').trigger('click');
     }
 }
})
}

//#endregion

//#region Delivery Select 




//#endregion

//#region Sort Select 

function initSortSelect() {
    
    let sortSelect, i, j, lenSortSelect, lenSelectedElement, selectedElement, selectItemDiv, optionDiv, optionItemDiv;
    
    /* Look for any elements with the class "custom-select": */
    sortSelect = document.getElementsByClassName("sort-select");
    lenSortSelect = sortSelect.length;
    
    for (i = 0; i < lenSortSelect; i++) {
        
        selectedElement = sortSelect[i].getElementsByTagName("select")[0];
        
        lenSelectedElement = selectedElement.length;
        
        /* For each element, create a new DIV that will act as the selected item: */
        selectItemDiv = document.createElement("div");
        
        selectItemDiv.setAttribute("class", "sort-select-selected sort-custom-selected");
        
        selectItemDiv.innerHTML = selectedElement.options[selectedElement.selectedIndex].innerHTML;
        
        sortSelect[i].appendChild(selectItemDiv);
        
        /* For each element, create a new DIV that will contain the option list: */        
        optionDiv = document.createElement("div");
        
        optionDiv.setAttribute("class", "sort-select-items sort-select-hide");
        
        for (j = 1; j < lenSelectedElement; j++) {
            
            /* For each option in the original select element,
            create a new DIV that will act as an option item: */
            optionItemDiv = document.createElement("div");
            
            optionItemDiv.innerHTML = selectedElement.options[j].innerHTML;
            
            optionItemDiv.addEventListener("click", function (e) {
                
                /* When an item is clicked, update the original select box,
                and the selected item: */
                
                var sameAsSelected, m, k, originalSelect, lastNode, lenOrigSelect, lenSameAsSelected;
                
                originalSelect = this.parentNode.parentNode.getElementsByTagName("select")[0];
                
                lenOrigSelect = originalSelect.length;
                
                lastNode = this.parentNode.previousSibling;
                
                for (m = 0; m < lenOrigSelect; m++) {
                    
                    if (originalSelect.options[m].innerHTML == this.innerHTML) {
                        
                        originalSelect.selectedIndex = m;
                        
                        lastNode.innerHTML = this.innerHTML;
                        
                        sameAsSelected = this.parentNode.getElementsByClassName("same-as-selected-sort");
                        
                        lenSameAsSelected = sameAsSelected.length;
                        
                        for (k = 0; k < lenSameAsSelected; k++) {
                            sameAsSelected[k].removeAttribute("class");
                        }
                        
                        this.setAttribute("class", "same-as-selected-sort");

                        let sort_config_grid = getConfigSortGrid();
                        let sortby = sort_config_grid[0];
                        let sortDirection = sort_config_grid[1];
                        getDiamonds(1, sortby, sortDirection);                            
                        
                        break;
                    }
                }

                lastNode.click();
            });

            if (j === 1) {
                
                if (optionItemDiv.hasAttribute('class')) {
                    optionItemDiv.classList.add('sort-border-firstopt');
                }
                else {
                    optionItemDiv.setAttribute('class', 'sort-border-firstopt');
                }  
            }

            optionDiv.appendChild(optionItemDiv);
        }

        sortSelect[i].appendChild(optionDiv);

        selectItemDiv.addEventListener("click", function (e) {
            $('table#table-results th.text-center').removeClass('bold-header');
            /* When the select box is clicked, close any other select boxes,
            and open/close the current select box: */
            e.stopPropagation();
            
            closeAllSelectSort(this);
            
            this.nextSibling.classList.toggle("sort-select-hide");
            
            this.classList.toggle("sort-select-arrow-active");

            
            
        });
    }
}

function closeAllSelectSort(elmnt) {
    /* A function that will close all select boxes in the document,
    except the current select box: */
    var selectItems, selectSelected, i, lenSelectItems, lenSelectSelected, arrNo = [];
    
    selectItems = document.getElementsByClassName("sort-select-items");
    
    selectSelected = document.getElementsByClassName("sort-select-selected");
    
    lenSelectItems = selectItems.length;
    
    lenSelectSelected = selectSelected.length;
    
    for (i = 0; i < lenSelectSelected; i++) {
        if (elmnt == selectSelected[i]) {
            arrNo.push(i)
        } else {
            selectSelected[i].classList.remove("sort-select-arrow-active");
        }
    }
    
    for (i = 0; i < lenSelectItems; i++) {
        if (arrNo.indexOf(i)) {
            selectItems[i].classList.add("sort-select-hide");
        }
    }
}

//#endregion

//#region View Select 

function changeViewSelect() {
    let selectView = document.getElementById('selectView');
    let viewSelected = selectView.options[selectView.selectedIndex].value;
    sessionStorage.setItem("wizardViewSelected", viewSelected);

    if (viewSelected === 'list') {
       
        typeView='allDiamonds';

        resetHeadersTableResults();

        document.getElementById('grid-view').classList.add('hidden');
        document.getElementById('list-view').classList.remove('hidden');
        document.getElementById('divSelectSort').classList.add('hidden');
        document.getElementById('results').classList.add('container-listview'); 
        document.getElementById('btn-container-wishList').classList.add('hidden');
        document.getElementById('btn-reset-filters').classList.remove('btn-reset-filters');
        document.getElementById("btn-reset-filters").classList.add('btn-reset-filters-max'); 

        document.getElementById('btn-group-grilla').getElementsByTagName('button')[0].classList.add('add_border');  
        document.getElementById('btn-container-wishList').getElementsByTagName('button')[0].classList.remove('add_border');
    }
    else {
      if ( typeView ==='wishList') {
        createCardGridWishList(); 
      } else {
        
        resetSortSelectGrid();
        
        document.getElementById('list-view').classList.add('hidden');
        document.getElementById('grid-view').classList.remove('hidden');
        document.getElementById('divSelectSort').classList.remove('hidden');
        document.getElementById('results').classList.remove('container-listview');
        
        document.getElementById('btn-container-wishList').classList.remove('hidden');

        document.getElementById('btn-reset-filters').classList.remove('btn-reset-filters-max');
        document.getElementById("btn-reset-filters").classList.add('btn-reset-filters'); 
      }
      
        
    }

    getDiamonds();
}

function initViewSelect() {
    
    let viewSelect, i, j, lenViewSelect, lenSelectedElement, selectedElement, selectItemDiv, optionDiv, optionItemDiv;
    
    /* Look for any elements with the class "custom-select": */
    viewSelect = document.getElementsByClassName("view-select");
    lenViewSelect = viewSelect.length;
    
    for (i = 0; i < lenViewSelect; i++) {
        
        selectedElement = viewSelect[i].getElementsByTagName("select")[0];
        
        lenSelectedElement = selectedElement.length;
        
        /* For each element, create a new DIV that will act as the selected item: */
        selectItemDiv = document.createElement("div");
        
        selectItemDiv.setAttribute("class", "view-select-selected view-custom-selected");
        
        selectItemDiv.innerHTML = selectedElement.options[selectedElement.selectedIndex].innerHTML;
        
        viewSelect[i].appendChild(selectItemDiv);
        
        /* For each element, create a new DIV that will contain the option list: */        
        optionDiv = document.createElement("div");
        
        optionDiv.setAttribute("class", "view-select-items view-select-hide");
        
        for (j = 1; j < lenSelectedElement; j++) {
            
            /* For each option in the original select element,
            create a new DIV that will act as an option item: */
            optionItemDiv = document.createElement("div");
            
            optionItemDiv.innerHTML = selectedElement.options[j].innerHTML;
            
            optionItemDiv.addEventListener("click", function (e) {
                
                /* When an item is clicked, update the original select box,
                and the selected item: */
                
                var sameAsSelected, m, k, originalSelect, lastNode, lenOrigSelect, lenSameAsSelected;
                
                originalSelect = this.parentNode.parentNode.getElementsByTagName("select")[0];
                
                lenOrigSelect = originalSelect.length;
                
                lastNode = this.parentNode.previousSibling;
                
                for (m = 0; m < lenOrigSelect; m++) {
                    
                    if (originalSelect.options[m].innerHTML == this.innerHTML) {
                        
                        originalSelect.selectedIndex = m;
                        
                        lastNode.innerHTML = this.innerHTML;
                        
                        sameAsSelected = this.parentNode.getElementsByClassName("same-as-selected-view");
                        
                        lenSameAsSelected = sameAsSelected.length;
                        
                        for (k = 0; k < lenSameAsSelected; k++) {
                            sameAsSelected[k].removeAttribute("class");
                        }
                        
                        this.setAttribute("class", "same-as-selected-view");

                        changeViewSelect();                          
                        
                        break;
                    }
                }

                lastNode.click();
            });

            if (j === 1) {
                
                if (optionItemDiv.hasAttribute('class')) {
                    optionItemDiv.classList.add('view-border-firstopt');
                }
                else {
                    optionItemDiv.setAttribute('class', 'view-border-firstopt');
                }  
            }

            optionDiv.appendChild(optionItemDiv);
        }

        viewSelect[i].appendChild(optionDiv);

        selectItemDiv.addEventListener("click", function (e) {
     
            /* When the select box is clicked, close any other select boxes,
            and open/close the current select box: */
            e.stopPropagation();
            
            closeAllSelectView(this);
            
            this.nextSibling.classList.toggle("view-select-hide");
            
            this.classList.toggle("view-select-arrow-active");           
            
        });
    }

  let viewSelected = sessionStorage.getItem("wizardViewSelected");
  if(viewSelected != null && viewSelected == 'list') {
    document.getElementById('selectView').value = viewSelected;
    document.getElementById('grid-searchzone').style.display = "none";
    document.getElementById('grid-searchzone').classList.remove('d-flex');
    document.getElementById('divSelectSort').classList.add('hidden');
    document.getElementById('btn-container-wishList').classList.add('hidden');
    document.getElementById('btn-reset-filters').classList.remove('btn-reset-filters');
    document.getElementById("btn-reset-filters").classList.add('btn-reset-filters-max');
    let selectSelected = document.getElementsByClassName("view-select-selected");
    if(selectSelected && selectSelected.length > 0) {
      selectSelected[0].innerHTML = 'List View';
    }
  }
}

function closeAllSelectView(elmnt) {
    
    /* A function that will close all select boxes in the document,
    except the current select box: */
    var selectItems, selectSelected, i, lenSelectItems, lenSelectSelected, arrNo = [];
    
    selectItems = document.getElementsByClassName("view-select-items");
    
    selectSelected = document.getElementsByClassName("view-select-selected");
    
    lenSelectItems = selectItems.length;
    
    lenSelectSelected = selectSelected.length;
    
    for (i = 0; i < lenSelectSelected; i++) {
        if (elmnt == selectSelected[i]) {
            arrNo.push(i)
        } else {
            selectSelected[i].classList.remove("view-select-arrow-active");
        }
    }
    
    for (i = 0; i < lenSelectItems; i++) {
        if (arrNo.indexOf(i)) {
            selectItems[i].classList.add("view-select-hide");
        }
    }
}

//#endregion

async function getResults(npage,pagination) {
     if($('gemstone-jumper.gemstone-jumper.active').length >= 1 && $('.bar-filter').length <= 0){
    var thum_index = $('gemstone-jumper.gemstone-jumper.active').attr('data-index');
    var prefferd_no = parseInt(thum_index)+1;
    filters.gemstones = [];
    filters.ColorHue = [];
    $('.main_gems_slider.gemstone_slider_main .inner_main_gems_slider[data-slick-index="'+prefferd_no+'"] .inner_main').each(function(){
    filters.gemstones.push($(this).find('input.gemstone-shape-option').val());
    var shape_option  = $(this).find('input.gemstone-shape-option').val();
    var colorhue =$(this).find('.container-img-gemstone input').val();
   
    if(colorhue == undefined){
      colorhue = ''
    }
    filters.ColorHue.push(`{shape_option:${shape_option},colorhue:${colorhue}}`);
  })
   } 
    let sortby;
    let sortdirection;
    let viewSelected = document.getElementById('selectView').options[selectView.selectedIndex].value;

    document.getElementById('btn-group-grilla').getElementsByTagName('button')[0].classList.add('add_border');  
  document.getElementById('btn-container-wishList').getElementsByTagName('button')[0].classList.remove('add_border');
   if($('#table-results th.text-center.bold-header').length > 0){
    if (viewSelected === 'list') {
        let sort_config_table = getSortConfigTableResults();
        sortby = sort_config_table[0];
        sortdirection = sort_config_table[1];
      
    }
    else {
        resetSortSelectGrid();
        sortby = 'total_sales_price';
        sortdirection = 'ASC';
    }
   }else{
  let sort_config_grid = getConfigSortGrid()
    sortby = sort_config_grid[0];
    sortdirection = sort_config_grid[1];
   
   }
   await getDiamonds(npage, sortby, sortdirection,pagination);
}

function showNoResults() {
    document.getElementById('errorzone').style.display = 'block';
    const errormsj = document.createElement('div');
    errormsj.classList.add('d-flex', 'justify-content-center');
    errormsj.innerHTML = `<h4>Unfortunately, no gemstones match the selected filters.</h4>`;
    document.getElementById('errorzone').appendChild(errormsj);
}

function getFiltersData() {
    /*
    If this starts from a Setting we need to get the boundaries of the filters from the localStorage (if they exist)
    */
    let wizardInfo = JSON.parse(localStorage.getItem('latestSearchGemstone')); 
    let wizardStart;
    wizardStart= JSON.parse(localStorage.getItem('wizardStart'));
    let min_allowed_carat =  initFiltValues.carat[0];
    let max_allowed_carat = initFiltValues.carat[1];
    let allowed_shapes = [];
    if(wizardInfo != null){
      if(wizardInfo.setting_max_carat_size != null){
        max_allowed_carat = parseFloat(wizardInfo.setting_max_carat_size) + 0.10;
        min_allowed_carat = parseFloat(wizardInfo.setting_min_carat_size) - 0.10;
        allowed_shapes = wizardInfo.setting_allowed_shapes;
        filters.shapes = filters.shapes.length>0?filters.shapes:wizardInfo.setting_allowed_shapes;
    }
    
    }

    let fluorFilter;
    let shapesFilter;
    let qualityFilter;
    let colorHueFilter;
    let certficateFilter;
    let oneofkindFilter
    let originFilter;
    let treatmentFilter;
    let heartsArrowsFilter;
    let citiesFilter;
    let countryFilter;
    let latestSearchGemstone = localStorage.getItem('latestSearchGemstone');
    shapesFilter = '';
    if (filters.shapes.length > 0) {
        if(allowed_shapes.length > 0){
            //End result shapes
            shapesFilterArray = [];
            filters.shapes.forEach(element => {
                if(allowed_shapes.includes(element)){
                    shapesFilterArray.push(element);
                }
            });
            shapesFilter = `,"Shapes": [${shapesFilterArray.map(item => `"${item}"`)}]`;

        }
        else {
            shapesFilter = `,"Shapes": [${filters.shapes.map(item => `"${item}"`)}]`;
        }
    }
   qualityFilter = '';
   if (filters.quality.length > 0) {
            qualityFilter = `,"Quality": [${filters.quality.map(item => `"${item}"`)}]`;
    }
  gemstonesFilter = '';
   if (filters.gemstones.length > 0) {
   gemstonesFilter = `,"Gemstones": [${filters.gemstones.map(item => `"${item}"`)}]`;
    }
  colorHueFilter = '';
  if (filters.ColorHue.length > 0) {
     colorHueFilter = `,"ColorHue": [${filters.ColorHue.map(item => `"${item}"`)}]`;
   }
    certficateFilter = '';
    if (filters.certificate.length > 0) {
        certficateFilter = `,"Certficate": [${filters.certificate.map(item => `"${item}"`)}]`;
    }
  oneofkindFilter = '';
    if (filters.certificate2.length > 0) {
     oneofkindFilter = `,"oneofakind": [${filters.certificate2.map(item => `"${item}"`)}]`;
    }
  
    treatmentFilter = '';
    if (filters.treatment.length > 0) {
        treatmentFilter = `,"Treatment": [${filters.treatment.map(item => `"${item}"`)}]`;
    } 
    originFilter = '';
    if (filters.origin.length > 0) {
        originFilter = `,"Origin": [${filters.origin.map(item => `"${item}"`)}]`;
    }
    dimensionFilter = '';
    if (filters.dimension.length > 0) {
        dimensionFilter = `,"Dimension": [${filters.dimension.map(item => `"${item}"`)}]`;
    }
    heartsArrowsFilter = '';
    if(filters.heartsandarrow != '') {
        heartsArrowsFilter = `,"brand": ${filters.heartsandarrow}`;
    }

    citiesFilter = '';
    countryFilter = '';
    if(filters.quickship != '') {
        citiesFilter = `,"cities": ${filters.quickship}`;
    }
    else {
        
        if(filters.delivery_country != '') {
            countryFilter = `,"country": ${filters.delivery_country}`;
        }

        if (filters.delivery_city != '') {
            citiesFilter = `,"cities": ${filters.delivery_city}`;
        }
    }
    // let's set the carat_min and max boundaries 
    if(filters.carat_min < min_allowed_carat){
        filters.carat_min = min_allowed_carat;
    }
    if(filters.carat_max > max_allowed_carat){
        filters.carat_max = max_allowed_carat;
    }
    // let filtersData = `{
    //     "search_type": "${filters.search_type}",     
    //     }`;
    let filtersData = `{       
        "size_from": "${filters.carat_min}",
        "size_to": "${filters.carat_max}",
        "price_total_from": "${filters.price_min}",
        "price_total_to": "${filters.price_max}"
        ${colorHueFilter}
         ${gemstonesFilter}
         ${qualityFilter}
         ${certficateFilter}
         ${oneofkindFilter}
         ${shapesFilter}
         ${treatmentFilter}
         ${originFilter}
         ${dimensionFilter}
        }`;

    return filtersData;
}

let fetchController = null;

async function getDiamonds(npage , sortby, sortdirection,pagination) {

   if(npage == undefined){
    npage = 1;
     }if(sortby == undefined){
     sortby = "Price2Total"
     }if(sortdirection == undefined){
     sortdirection = "ASC"
     }
    let url = window.API_URL + `diamonds/gemstone/all?page=${npage}&limit=${RESULTS_PER_PAGE}&sort_by=${sortby}&direction=${sortdirection}`;
     if(pagination == true){
              // document.getElementById('bottom_pagination_spinner').classList.remove('hidden');
              // document.getElementById('bottom_pagination_spinner').classList.add('d-flex');  
              $('.load-more-product').html(`<div class="host"><div class="loading1 loading-0"></div><div class="loading1 loading-1"></div><div class="loading1 loading-2"></div></div>`)
      }
    let viewSelected = document.getElementById('selectView').options[selectView.selectedIndex].value;
    let filtersData = getFiltersData();
    document.getElementById('errorzone').innerHTML = '';
    document.getElementById('errorzone').style.display = 'none';
    let grid_wrapper = ''
    let grid_wrapper2 = ''
    let grid_wrapper3 = ''
    let grid_wrapper4 = ''
    grid_wrapper = document.createElement('div');
    grid_wrapper2 = document.createElement('div');
    grid_wrapper3 = document.createElement('div');
    grid_wrapper4 = document.createElement('div');
    grid_wrapper.classList.add('prod', 'contenCuadro');
    grid_wrapper2.classList.add('prod', 'contenCuadro');
    grid_wrapper3.classList.add('prod', 'contenCuadro');
    grid_wrapper4.classList.add('prod', 'contenCuadro');
    if(pagination != true){
    document.getElementById('grid-view').innerHTML = '';
    document.getElementById('table-results').tBodies[0].innerHTML = '';
    }
    document.getElementById('btn-group-grilla').getElementsByTagName('button')[0].classList.add('add_border');  
    document.getElementById('btn-container-wishList').getElementsByTagName('button')[0].classList.remove('add_border');

    if (viewSelected === 'list' && pagination != true) {
        document.getElementById('list-searchzone').style.display = "flex";
      document.getElementById('btn-container-wishList').classList.add('hidden');
    }
    else if(pagination != true) {        
     
        document.getElementById('grid-searchzone').style.display = "flex";
    }

    let paginationZone = document.getElementById('pagination-zone');
    paginationZone.style.visibility = "hidden";

    if(fetchController) {
      fetchController.abort();
    }
    fetchController = new AbortController();
  
    let gd = await fetch(url, {
        signal: fetchController.signal,
        method: 'POST',
        body: filtersData,
        headers: { 'Content-type': 'application/json', 'Accept': `application/json`,'X-API-Key': 'TSANITY121A3VG7NEMVRXXEWGM' }
    }).then(res => res.json())
        .then(response => {
          
            let diamonds = response.diamonds;
            let total_res = diamonds.length;
            if(total_res == 0){
              $('#Huratips-Pagination').hide();
            }
            let quant_results = document.getElementById('quant-results');
            if (response.search.total > 0) {  
                let quant_results_rapnet = response.search.total;
                let quant_pages = quant_results_rapnet > 0 ? Math.ceil(parseInt(quant_results_rapnet) / RESULTS_PER_PAGE) : 0;

                paginationZone.style.visibility = "visible";
                document.getElementById('pagination-zone-nav').innerHTML = '';
                createPaginationPages(npage, quant_pages);

                if (viewSelected === 'list') {
                    document.getElementById('list-searchzone').style.display = "none";
                    document.getElementById('list-view').classList.remove('hidden');
                    document.getElementById('grid-searchzone').classList.remove('d-flex');
                  document.getElementById('grid-searchzone').style.display = "none";
                  document.getElementById('btn-container-wishList').classList.add('hidden');
                
                }
                else {
                    document.getElementById('grid-searchzone').style.display = "none";
                    document.getElementById('grid-searchzone').classList.remove('d-flex');                    
                }

                quant_results.textContent = quant_results_rapnet;
               $('#Huratips-Pagination .show-prod-content .total_exist').text(quant_results_rapnet);
                getNumberOfPages(npage, quant_pages);
               var rendom_no =  Math.floor(Math.random() * 10) + 1;
               var total_no_of_pd = 0;
                diamonds.forEach((diamond ,index)=> {
                  console.log("<<<<diamonds>>>>>");
                  console.log(diamond);
                  console.log("<<<<diamonds>>>>>");
                     total_no_of_pd = total_no_of_pd+index;
                    if (viewSelected === 'list') {
                        createRowTableResults(diamond,pagination,index,rendom_no);
                    }
                    else {                        
                        createCardGrid(diamond,total_res,pagination,index,rendom_no,grid_wrapper,grid_wrapper2,grid_wrapper3,grid_wrapper4);
                    }
                });                
                  if(total_no_of_pd < 9){
                $('div#list-view').css('height','auto');
                 }else{
                   $('div#list-view').css('height','990px'); 
                 }     
            }
            else {
                quant_results.textContent = '(0)';
                paginationZone.style.visibility = "hidden";

                if (viewSelected === 'list') {
                    document.getElementById('list-view').classList.add('hidden');   
                    
                }
                else {
                    document.getElementById('grid-searchzone').style.display = "none";
                    document.getElementById('grid-searchzone').classList.remove('d-flex');                    
                }

                showNoResults();
            }
             if(pagination == true){
               //document.getElementById('bottom_pagination_spinner').classList.add('hidden');
               //document.getElementById('bottom_pagination_spinner').classList.remove('d-flex'); 
                $('.load-more-product').html(` Load More Product`);
             }
            latestSearchGemstone = {};
            console.log(filters);
            latestSearchGemstone.filters = filters;
            if($('#bar-filter[data-name="Pear"],#bar-filter[data-name="Princess"],#bar-filter[data-name="Emerald"],#bar-filter[data-name="Marquise"],#bar-filter[data-name="Asscher"],#bar-filter[data-name="Radiant"],#bar-filter[data-name="Heart"],#bar-filter[data-name="Cushion"],#bar-filter[data-name="Oval"],#bar-filter[data-name="Round"]').length<1){
             latestSearchGemstone.filters.shapes = [];  
            }
            window.localStorage.setItem('latestSearchGemstone', JSON.stringify(latestSearchGemstone));
           var active_filter_no = $('.bar_filters #bar-filter').length;
          if($(window).width() > 989){
          if(active_filter_no >0 || $('gemstone-jumper.gemstone-jumper.active').length >= 1){ 
         
          $('#btn-reset-filters').show();
          }else{
            $('#btn-reset-filters').hide();
          }
          }
           if($(window).width() < 989){
          if(active_filter_no >0 || $('gemstone-jumper.gemstone-jumper.active').length >= 1){ 
         
            $('#btn-reset-filters-2').show();
          }else{
            $('#btn-reset-filters-2').hide();
          }
          }
           $('#btn-reset-filters .filter_count,#btn-reset-filters-2 .filter_count').text("("+active_filter_no+")");
        })
        .catch(error => console.error('Error:', error));   
}
 function getgemstoneResults(){
    let gdt = fetch(window.API_URL+`diamonds/findGemsotoneShape/shape/find`, {
        method: 'POST',
        body: JSON.stringify(gemstonesfilters),
        headers: { 'Content-type': 'application/json', 'Accept': `application/json`,'X-API-Key': 'TSANITY121A3VG7NEMVRXXEWGM' }
    }).then(res => res.json())
        .then(response => {
    if(response[0] != undefined && $('.inner_main input:checked').length >0){
    $('.shape-container-gemstones').hide();
      $(response).each(function(index,items){
        $('.shape-container-gemstones[data-shape="'+items.shape+'"]').show();
      })
    }else{
    $('.shape-container-gemstones').show();
    }
    getResults();
    }).catch(error =>{ console.error('Error:', error);
                     });  
}
function functionGetAllFiltersValues() {
    getPriceFilterValues();
    getCaratFilterValues();
    getShapeFilterValues();
    getQualityFilterValues();
    getCertificateFilterValues();
    getOnofkindFilterValues();
    getTreatmentFilterValues();
    getOriginFilterValues();
    getDimensionFilterValues();
    getGemstoneFilterValues();
}



function firsTimeCall() {
  functionGetAllFiltersValues();

}

function setFiltersValues(latestSearchGemstone) {
    priceSlider.noUiSlider.set([latestSearchGemstone.filters.price_min, latestSearchGemstone.filters.price_max]);
     let priceFilter = priceSlider.noUiSlider.get();
     let min_price = formatPrice(parseInt(priceFilter[0]))
     let max_price = formatPrice(parseInt(priceFilter[1]))
   if(parseInt(priceFilter[0]) > parseInt(initFiltValues.price[0]) || parseInt(priceFilter[1]) < parseInt(initFiltValues.price[1])){
     bar_filter('Price',min_price,max_price);
   }
    caratSlider.noUiSlider.set([latestSearchGemstone.filters.carat_min, latestSearchGemstone.filters.carat_max]);
     let caratFillter = caratSlider.noUiSlider.get();
    if(caratFillter[0] > initFiltValues.carat[0] || caratFillter[1] < initFiltValues.carat[1])
    {
      bar_filter('Carat',caratFillter[0].toString(),caratFillter[1].toString());
    }
    
    latestSearchGemstone.filters.shapes.forEach(shape => {
        document.getElementById("shape-"+shape.toLowerCase()).checked = true;
        document.getElementById("shape-"+shape.toLowerCase()).parentNode.classList.add('active');
        bar_filter(shape);
    });
   
    filters = latestSearchGemstone.filters;
    getDiamonds();
    
}


function bar_filter(name,filter_from,filter_to){
  if(name == 'remove'){
    $('#bar-filter.col-2').remove()
  }else{
    let hypen = '-'
    if(filter_from == undefined){
     $('#bar-filter .show_hypen').addClass('hide')
     filter_from = '' 
      hypen=''
    }
    if(filter_to == undefined){
      filter_to = ''
      hypen=''
    }
 $('.container-diamondresults .bar_filters').append(
    `<div class="col-2 small-hide medium-hide bar-filter" id="bar-filter" data-name="${name}">
                   <div class="btn-results btn-all-results bar_filter"><span class="main_fliter_text">${filter_from} ${hypen} ${filter_to} ${name}</span>
                        <span class='clear'>x</span>
                  </div>
      </div> `)
   }
}
$(document).on('click','.bar-filter',function(){
      var value_gem = $(this).attr('data-name');
      if($('.inner_main input.gemstone-shape-option[value="'+value_gem+'"]:checked')){
      if('.inner_main_gems_slider.Prefferd_gemstone .inner_main input.gemstone-shape-option[value="'+value_gem+'"]:checked'){
          $('.inner_main input.gemstone-shape-option[value="'+value_gem+'"]').prop('checked',false);
          $('.inner_main_gems_slider.main_gemstone_slide .inner_main').each(function(){
          var _this = $(this).find('.gemstone-shape-option');
          var mach_val =  $(this).find('.gemstone-shape-option').attr('data_gemstone_name');
          if(mach_val.includes(value_gem)){
          $(_this).prop("checked",false);
          }
          })
      }else{
      $('.inner_main input.gemstone-shape-option[value="'+value_gem+'"]').prop('checked',false);
       
      }
       getGemstoneFilterValues();
       getgemstoneResults();
      }
      if($(this).attr('data-name') == 'Clarity'){
      claritySlider.noUiSlider.set(initFiltValues.clarity);
        getClarityFilterValues();
      }
    
    if($(this).attr('data-name') == 'Price')
    {
    priceSlider.noUiSlider.set(initFiltValues.price);
     getPriceFilterValues();
    }
  
 
    if($(this).attr('data-name') == 'UNTREATED'){
    document.getElementById('untreated').checked = false;
    getTreatmentFilterValues();
    
    }
    if($(this).attr('data-name') == 'TREATED'){
    document.getElementById('treated').checked = false;
    getTreatmentFilterValues();
    
    }
  
   if($(this).attr('data-name') == 'Princess'){
     document.getElementById('shape-princess').checked = false;
     getShapeFilterValues();
   }
   if($(this).attr('data-name') == 'Pear'){
     document.getElementById('shape-pear').checked = false;
     getShapeFilterValues();
   }
   if($.trim($(this).attr('data-name')) == 'Round'){
     document.getElementById('shape-round').checked = false;
     getShapeFilterValues();
   }
   if($(this).attr('data-name') == 'Oval'){
     document.getElementById('shape-oval').checked = false;
     getShapeFilterValues();
   }
  if($(this).attr('data-name') == 'Cushion'){
    document.getElementById('shape-cushion').checked = false;
    getShapeFilterValues();
  }
  if($(this).attr('data-name') == 'Emerald'){
    document.getElementById('shape-emerald').checked = false;
    getShapeFilterValues();
   }
  if($(this).attr('data-name') == 'Marquise'){
    document.getElementById('shape-marquise').checked = false;
    getShapeFilterValues();
  }
  if($(this).attr('data-name') == 'Asscher'){
    document.getElementById('shape-asscher').checked = false;
    getShapeFilterValues();
  }
   if($(this).attr('data-name') == 'Radiant'){
     document.getElementById('shape-radiant').checked = false;
     getShapeFilterValues();
   }
  if($(this).attr('data-name') == 'Heart'){
    document.getElementById('shape-heart').checked = false;
     getShapeFilterValues();
  }


  if($(this).attr('data-name') == 'Carat'){
    caratSlider.noUiSlider.set(initFiltValues.carat);
    getCaratFilterValues();
  }

if($(this).attr('data-name') == 'CERTIFIED'){
    document.getElementById('certificate-certified').checked = false;
    getCertificateFilterValues();
  }
  if($(this).attr('data-name') == 'one of kind'){
    document.getElementById('certificate-oneofakind').checked = false;
    getOnofkindFilterValues();
  }
  
if($(this).attr('data-name') == 'Good'){
    document.getElementById('quality-good').checked = false;
    getQualityFilterValues();
  }
if($(this).attr('data-name') == 'Fine'){
    document.getElementById('quality-good').checked = false;
    getQualityFilterValues();
  }
if($(this).attr('data-name') == 'Premium'){
    document.getElementById('quality-premium').checked = false;
    getQualityFilterValues();
  }
if($(this).attr('data-name') == 'Exceptional'){
    document.getElementById('quality-exceptional').checked = false;
    getQualityFilterValues();
  }
if($(this).attr('data-name') == 'NATURAL'){
    document.getElementById('natural').checked = false;
    getOriginFilterValues();
  }
if($(this).attr('data-name') == 'LAB CREATED'){
    document.getElementById('labcreated').checked = false;
    getOriginFilterValues();
  }
if($(this).attr('data-name') == 'UNDER-6MM'){
    
    document.getElementById('under-6mm').checked = false;
    getDimensionFilterValues();
  }
if($(this).attr('data-name') == '6-6.9MM'){
    document.getElementById('6-6-9mm').checked = false;
    getDimensionFilterValues();
  }
if($(this).attr('data-name') == '7-7.9MM'){
    document.getElementById('7-7-9mm').checked = false;
    getDimensionFilterValues();
  }
if($(this).attr('data-name') == '8-8.9MM'){
    document.getElementById('8-8-9mm').checked = false;
    getDimensionFilterValues();
  }
if($(this).attr('data-name') == '10+MM'){
    document.getElementById('10-mm').checked = false;
    getDimensionFilterValues();
    
  }
                                                                                                                         
  getResults();
})

function setLocalStorageId(stone_id,img,stone) {

    let wizardInfo = localStorage.getItem('wizardInfo_gemstone');    

   // localStorage.removeItem('wizardInfo');
    let gsize = stone.Title.split(' ')[0];
    if (wizardInfo != null) {        
        wizardInfo = JSON.parse(wizardInfo);
        wizardInfo.gemstone_id = stone.Stock;
        wizardInfo.gemstone_handle = stone.handle;
        wizardInfo.gemstone_image_url = stone.Image1;
        wizardInfo.gemstone_type = stone.MatchingNum.toLowerCase().replace(/ /g,"-");
        wizardInfo.gemstone_type1 = stone.Gemstone.toLowerCase().replace(/ /g,"-");
        wizardInfo.gemstone_shape = stone.Shape;
        wizardInfo.gemstone_size = gsize.replaceAll('.', '-');
    }
    else {
        wizardInfo = window.wizard_gemstone;
        wizardInfo.gemstone_id = stone.Stock;
        wizardInfo.gemstone_handle = stone.handle;
        wizardInfo.gemstone_image_url = stone.Image1;
        wizardInfo.gemstone_type = stone.MatchingNum.toLowerCase().replace(/ /g,"-");
        wizardInfo.gemstone_type1 = stone.Gemstone.toLowerCase().replace(/ /g,"-");
        wizardInfo.gemstone_shape = stone.Shape;
        wizardInfo.gemstone_size = gsize.replaceAll('.', '-');
    }

    localStorage.setItem("wizardInfo_gemstone", JSON.stringify(wizardInfo));
}

function handleResize() {
    if (window.innerWidth <= 375) {
        document.getElementById('first-filters-section').classList.add('hidden');

       
        document.getElementById('btn-reset-filters').classList.remove('btn-reset-filters');
        document.getElementById("btn-reset-filters").classList.add('btn-reset-filters-max'); 
    }
    else {
        if(document.getElementById('selectView').value != 'list') {
          document.getElementById("btn-reset-filters").classList.remove('btn-reset-filters-max'); 
          document.getElementById('btn-reset-filters').classList.add('btn-reset-filters');
        }

    }

    if (window.innerWidth <= 850) {
        document.getElementById('btn-reset-filters').classList.remove('btn-reset-filters');
        document.getElementById("btn-reset-filters").classList.add('btn-reset-filters-max'); 
    } else {
        if(document.getElementById('selectView').value != 'list') {
          document.getElementById("btn-reset-filters").classList.remove('btn-reset-filters-max'); 
          document.getElementById('btn-reset-filters').classList.add('btn-reset-filters');
        }
    }

    if (window.innerWidth <= 600) {
        document.getElementById('btn-group-grilla').classList.add('hidden');
        document.getElementById('btn-container-wishList').classList.add('hidden');
    } else {
        document.getElementById('btn-group-grilla').classList.remove('hidden');
        if(document.getElementById('selectView').value != 'list') {
          document.getElementById('btn-container-wishList').classList.remove('hidden');
        }
    }
}

window.addEventListener("resize", handleResize);
window.addEventListener("load", handleResize);
  
createFilters();
initSortSelect();
initViewSelect();
bindEvents();
firsTimeCall();

function isImage1(url) {
    if(url === undefined || url === null) return false;
    return(url.match(/\.(jpeg|jpg|gif|png)$/) != null);
}
function isV3601(url){
    if(url.indexOf('360') > -1){
        return true;
    }
    else{
        return false;
    }
}
function getDiamondImageUrl1(diamond){
    if(isImage(diamond.Image_URL)){
 
        return `<img  src='${diamond.Image_URL}'/>`;
    }       
    else{
        if(isV3601(diamond.Image_URL) == true){
            //set the innerHTML to an iframe loading diamond.Image_URL
            return `<iframe data-src="${diamond.Image_URL}" src="" width=420 height=420 sandbox="allow-scripts allow-orientation-lock allow-same-origin allow-pointer-lock"></iframe>`;        
        }
        else  {
            return `<img  src='${getDiamondLinesImgTableResults1(diamond.Shape)}'>`;
        }
    }
}
